/**
 * One region's view, at any depth (BON-534).
 *
 * The workshops for that region and everything beneath it. There is no
 * sub-region tile grid on ANY viewport: the design reaches a sub-region through
 * the scope picker on wide screens and through the filter chips above the
 * mobile list, so a tile section would be a third route down that the design
 * does not have.
 *
 * No day strip either — that belongs to the all-regions scope, and the criteria
 * say it never appears here.
 */
import { useAllRegionsOverview } from './overview-api';
import type { RegionOverviewDto } from './overview-types';
import { RegionWorkshops } from './RegionWorkshops';

export interface RegionOverviewProps {
  overview: RegionOverviewDto;
}

export function RegionOverview({ overview }: RegionOverviewProps) {
  // Warms the cache the scope picker reads, so opening it on a region page
  // does not wait on a request the roster has usually already made.
  useAllRegionsOverview();

  return <RegionWorkshops path={overview.region.path} />;
}
